var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"avatar-wrapper"},[_c('img',{staticClass:"imgA",attrs:{"src":_vm.src,"alt":""}}),(_vm.checked)?_c('span',{staticClass:"iconfont gou"},[_vm._v("")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }